import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, HostBinding, Inject, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Observable, Subject, combineLatest, map, take } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { Stats } from "src/app/models/stats.model";


import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";

export let applicationVersionFromHome: string = "";

import { PraticaScuola_Firestore } from "src/app/models/praticaScuolaFirestore.model";
import { onSnapshot } from "firebase/firestore";
import { TabViewChangeEvent } from "primeng/tabview";
import { environment } from "src/environments/environment";
import { PraticaSanita_Firestore } from "src/app/models/praticaSanitaFirestore.model";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";


declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-fase3",
  templateUrl: "./home.fase3.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeFase3Flowdy2Component implements OnInit {
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;

  ref: DynamicDialogRef;

    protected stats: StatsFlowdy2 = new StatsFlowdy2();
  

  protected praticheBando1Totali = 100;
  protected praticheBando1InLavorazione = 20;

  protected praticheBando2Totali = 200;
  protected praticheBando2InLavorazione = 40;

  protected isLoading: boolean    = false;
  protected isAdmin:      boolean = false;
  protected isSuperAdmin: boolean = false;
  protected isPM:         boolean = false;
  protected isDipendente: boolean = true;
  protected hasBando1: boolean    = false;
  protected hasBando2: boolean    = false;

  private collection_pratiche:string  = environment.firebase.collection_pratiche;
  private collection_importLog:string = environment.firebase.collection_import_log;

  //CSV BOX
  private csvbox_licenseKey_aggiornaPratiche:string=environment.csvBox.secret_aggiornaPratiche;
  private csvbox_licenseKey_aggiornaPraticheBando1:string=environment.csvBox.secret_aggiornaPraticheBando1;
  private csvbox_licenseKey_aggiornaPraticheSanita:string=environment.csvBox.secret_aggiornaPraticheSanita;
  private csvbox_user:string=environment.csvBox.user;
  private csvbox_importer_aggiornaPratiche:any;
  private csvbox_importer_aggiornaPraticheBando1:any;
  private csvbox_importer_aggiornaPraticheSanita:any;

  private bando1LoadingSubject = new Subject<boolean>();
  private bando2LoadingSubject = new Subject<boolean>();

  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
    private dipendenteService: UtentiService,
    private impreseService: ImpreseService,

    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    public firestore: AngularFirestore,
    private statsService: StatsService,
    
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {
    this.logger.info("[HOME FASE 3] ON INIT");
    
    // Gestione dello stato di caricamento combinato
    combineLatest([
      this.bando1LoadingSubject,
      this.bando2LoadingSubject
    ]).subscribe(([bando1Loading, bando2Loading]) => {
      this.isLoading = bando1Loading || bando2Loading;
    });

    // Inizializzazione CSVBox solo se necessario
    if (this.isAdmin || this.isSuperAdmin) {
      this.initCSVBox();
    }
    
    this.setUserRole();
  }
  setUserRole(){
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PM"
    ) {
      this.isPM = true;
    }
  }
  private initCSVBox() {
    try {
      if (typeof CSVBoxImporter !== 'undefined') {
        this.csvbox_importer_aggiornaPratiche = new CSVBoxImporter(
          this.csvbox_licenseKey_aggiornaPratiche, 
          {}, 
          (result: boolean, data: any) => {
            if (result) {
              this.logger.info('[CSVBox] Import completato con successo');
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Errore',
                detail: 'Errore durante l\'importazione dei dati',
                life: 10000
              });
            }
          }
        );

        if (this.csvbox_importer_aggiornaPratiche) {
          this.csvbox_importer_aggiornaPratiche.setUser({
            user_id: this.csvbox_user || "default123"
          });
          this.csvbox_importer_aggiornaPratiche.language = "it";
        }
      } else {
        this.logger.warn('[CSVBox] CSVBoxImporter non disponibile');
      }
    } catch (error) {
      this.logger.error('[CSVBox] Errore durante l\'inizializzazione:', error);
    }
  }

   ngOnChanges(changes: SimpleChanges) {
     
      if (changes['impresa'] && changes['impresa'].currentValue) {
        this.impresa = changes['impresa'].currentValue;
      }
      if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
        this.isImpresa = changes['isImpresa'].currentValue;
      }
      if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
        this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
      }
  
      if( (changes['isImpresa'] && changes['isImpresa'].currentValue) || (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) || (changes['impresa'] && changes['impresa'].currentValue)){
        this.loadDatiBando1();
        this.loadDatiBando2();
      }
    }

    loadDatiBando1(){
        /*  if(this.isImpresa){
          this.logger.info('[HOME FASE3] INIZIO CARICAMENTO DATI BANDO 1 PER IMPRESA');
        }else if(this.isPresidioTIM){
          this.logger.info('[HOME FASE3] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO TIM');
        }else{
          this.logger.info('[HOME FASE3] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO');
        }  */
        this.bando1LoadingSubject.next(true);
        const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let queryBando1  ;
        if(this.isImpresa){
          queryBando1 = collectionRef
                        .where("idAzienda", "==", this.userService.getUser().azienda.id)
           //             .where("codiceStatoInfratelFase1", "==", "1-6")
                        .where("codiceStatoInfratelFase2", "==", "2-6")
                       // .where("codiceStatoInfratelFase3", "==", "3-1")
                        .where("bando", "==", "BANDO 1");
         }else{
          queryBando1 = collectionRef
              //          .where("codiceStatoInfratelFase1", "==", "1-6")
                        .where("codiceStatoInfratelFase2", "==", "2-6")
                     //     .where("codiceStatoInfratelFase3", "==", "3-1")
                          .where("bando", "==", "BANDO 1");
        }
        onSnapshot(queryBando1, (qs) => {
          this.stats.resetBando1();
          //this.logger.info('[HOME FASE3] DATI ARRIVATI PER BANDO 1: '+ qs.docs.length);
            qs.forEach((doc) => {
              let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
            //  if(praticaBando1DaFirestore.sopralluogoOk){
                this.stats.bando1Fase3++;
                switch (praticaBando1DaFirestore.codiceStatoInfratelFase3) {
                  case '3-1':
                    if(!this.isPresidioTIM){
                      this.stats.bando1Fase3InLavorazione ++;
                    }
                    this.stats.bando1Fase3_1 ++;
                    if(praticaBando1DaFirestore.lotto==='6'){
                      this.stats.bando1Fase3_1_lotto6++;
                    }else{
                      this.stats.bando1Fase3_1_lotto7++;
                    }
                    break;
                  case '3-2':
                    if(!this.isPresidioTIM){
                      this.stats.bando1Fase3InLavorazione ++;
                    }
                    this.stats.bando1Fase3_2 ++;
                    if(praticaBando1DaFirestore.lotto==='6'){
                      this.stats.bando1Fase3_2_lotto6++;
                    }else{
                      this.stats.bando1Fase3_2_lotto7++;
                    }
                    break;
                  case '3-3':
                    this.stats.bando1Fase3InLavorazione ++;

                    this.stats.bando1Fase3_3 ++;
                    if(praticaBando1DaFirestore.lotto==='6'){
                      this.stats.bando1Fase3_3_lotto6++;
                    }else{
                      this.stats.bando1Fase3_3_lotto7++;
                    }
                    break;
                  case '3-4':
                    this.stats.bando1Fase3InLavorazione ++;

                    this.stats.bando1Fase3_4 ++;
                    if(praticaBando1DaFirestore.lotto==='6'){
                      this.stats.bando1Fase3_4_lotto6++;
                    }else{
                      this.stats.bando1Fase3_4_lotto7++;
                    }
                    break;
                  case '3-5':
                    if(!this.isPresidioTIM){
                      this.stats.bando1Fase3InLavorazione ++;

                    }
                    this.stats.bando1Fase3_5 ++;
                    if(praticaBando1DaFirestore.lotto==='6'){
                      this.stats.bando1Fase3_5_lotto6++;
                    }else{
                      this.stats.bando1Fase3_5_lotto7++;
                    }
                    break;
                  default:

                    this.stats.bando1Fase3_6 ++;
                    if(praticaBando1DaFirestore.lotto==='6'){
                      this.stats.bando1Fase3_6_lotto6++;
                    }else{
                      this.stats.bando1Fase3_6_lotto7++;
                    }
                    break;
                }
            //  }
            });
            this.bando1LoadingSubject.next(false);
        });
      }
    
      loadDatiBando2(){
          if(this.isImpresa){
          this.logger.info('[HOME FASE3] INIZIO CARICAMENTO DATI BANDO 2 PER IMPRESA');
        }else if(this.isPresidioTIM){
          this.logger.info('[HOME FASE3] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO TIM');
        }else{
          this.logger.info('[HOME FASE3] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO @ '+ this.collection_pratiche);
        }  
        this.bando2LoadingSubject.next(true);
        const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let queryBando2  ;
        if(this.isImpresa){
            queryBando2 = collectionRef
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
              .where("bando", "==", "BANDO 2")
             // .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
            //  .where("codiceStatoInfratelFase3", "==", "3-1")
            ;
        }else{
          queryBando2 = collectionRef
             .where("bando", "==", "BANDO 2")
            // .where("codiceStatoInfratelFase1", "==", "1-6")
             .where("codiceStatoInfratelFase2", "==", "2-6")
           //  .where("codiceStatoInfratelFase3", "==", "3-1")
             ;
                 
        }
    
        onSnapshot(queryBando2, (qs) => {
          this.stats.resetBando2();
          this.logger.info('[HOME FASE3] DATI ARRIVATI PER BANDO 2: '+ qs.docs.length);
    
          qs.forEach((doc) => {
            let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
            // if(praticaBando2DaFirestore.sopralluogoOk){
              this.stats.bando2Fase3++;
              switch (praticaBando2DaFirestore.codiceStatoInfratelFase3) {
                case '3-1':

                  if(!this.isPresidioTIM){
                    this.stats.bando2Fase3InLavorazione ++;
                  }
                  this.stats.bando2Fase3_1 ++;
                  if(praticaBando2DaFirestore.lotto==='1'){
                    this.stats.bando2Fase3_1_lotto1++;
                  }else if(praticaBando2DaFirestore.lotto==='5'){
                    this.stats.bando2Fase3_1_lotto5++;
                  }else if(praticaBando2DaFirestore.lotto==='7'){
                    this.stats.bando2Fase3_1_lotto7++;
                  }else {
                    this.stats.bando2Fase3_1_lotto8++;
                  }
                  break;
                case '3-2':
                  if(!this.isPresidioTIM){
                    this.stats.bando2Fase3InLavorazione ++;
                  }
                  this.stats.bando2Fase3_2 ++;
                  if(praticaBando2DaFirestore.lotto==='1'){
                    this.stats.bando2Fase3_2_lotto1++;
                  }else if(praticaBando2DaFirestore.lotto==='5'){
                    this.stats.bando2Fase3_2_lotto5++;
                  }else if(praticaBando2DaFirestore.lotto==='7'){
                    this.stats.bando2Fase3_2_lotto7++;
                  }else {
                    this.stats.bando2Fase3_2_lotto8++;
                  }
                  break;
                case '3-3':
                  this.stats.bando2Fase3InLavorazione ++;
                  this.stats.bando2Fase3_3 ++;
                  if(praticaBando2DaFirestore.lotto==='1'){
                    this.stats.bando2Fase3_3_lotto1++;
                  }else if(praticaBando2DaFirestore.lotto==='5'){
                    this.stats.bando2Fase3_3_lotto5++;
                  }else if(praticaBando2DaFirestore.lotto==='7'){
                    this.stats.bando2Fase3_3_lotto7++;
                  }else {
                    this.stats.bando2Fase3_3_lotto8++;
                  }
                  break;
                case '3-4':
                  this.stats.bando2Fase3InLavorazione ++;
                  this.stats.bando2Fase3_4 ++;
                  if(praticaBando2DaFirestore.lotto==='1'){
                    this.stats.bando2Fase3_4_lotto1++;
                  }else if(praticaBando2DaFirestore.lotto==='5'){
                    this.stats.bando2Fase3_4_lotto5++;
                  }else if(praticaBando2DaFirestore.lotto==='7'){
                    this.stats.bando2Fase3_4_lotto7++;
                  }else {
                    this.stats.bando2Fase3_4_lotto8++;
                  }
                  break;
                case '3-5':
                  if(!this.isPresidioTIM){
                    this.stats.bando2Fase3InLavorazione ++;
                  }
                  this.stats.bando2Fase3_5 ++;
                  if(praticaBando2DaFirestore.lotto==='1'){
                    this.stats.bando2Fase3_5_lotto1++;
                  }else if(praticaBando2DaFirestore.lotto==='5'){
                    this.stats.bando2Fase3_5_lotto5++;
                  }else if(praticaBando2DaFirestore.lotto==='7'){
                    this.stats.bando2Fase3_5_lotto7++;
                  }else {
                    this.stats.bando2Fase3_5_lotto8++;
                  }
                  break;
                default:
                   // this.stats.bando2Fase3InLavorazione ++;
                    this.stats.bando2Fase3_6 ++;
                    if(praticaBando2DaFirestore.lotto==='1'){
                      this.stats.bando2Fase3_6_lotto1++;
                    }else if(praticaBando2DaFirestore.lotto==='5'){
                      this.stats.bando2Fase3_6_lotto5++;
                    }else if(praticaBando2DaFirestore.lotto==='7'){
                      this.stats.bando2Fase3_6_lotto7++;
                    }else {
                      this.stats.bando2Fase3_6_lotto8++;
                    }
                    break;
              }
           // } 
            
            
          });
            this.bando2LoadingSubject.next(false);
        });
      }

  openPraticheFase1(a:number, b:number){}

  aggiornaPratiche(bando:number){
    
  }

  openAllPraticheFase3(bando:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3']));
  }
  openPraticheFase3InLavorazione(bando:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3'],
      {
        queryParams: { 'in-lavorazione': true }, 
      }
    ));
  }

  openPraticheFase3(bando:number, stato:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3/stato/3-'+stato]));
  }

  openPraticheFase3PerLotto(bando:number, stato:number, lotto:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-3/stato/3-'+stato],
      {
        queryParams: { 'lotto': lotto }, // Può essere true o false
      })
    );
  }

  
  
}
